import PropertyCard from "./PropertyCard";
import { CardSkeleton, Empty } from "@/components/common/States";

export default function PropertyGrid({ items, loading, emptyTitle, emptyHint, emptyAction, testId = "property-grid", cols = "sm:grid-cols-2 lg:grid-cols-4" }) {
  if (loading) {
    return <div className={`grid gap-5 ${cols}`}>{Array.from({ length: 4 }).map((_, i) => <CardSkeleton key={i} />)}</div>;
  }
  if (!items?.length) return <Empty title={emptyTitle} hint={emptyHint} action={emptyAction} testId={`${testId}-empty`} />;
  return (
    <div data-testid={testId} className={`grid gap-5 ${cols}`}>
      {items.map((p) => <PropertyCard key={p.id} p={p} />)}
    </div>
  );
}
